import { render, staticRenderFns } from "./TagsComponent.vue?vue&type=template&id=5cafecd1&"
import script from "./TagsComponent.ts?vue&type=script&lang=ts&"
export * from "./TagsComponent.ts?vue&type=script&lang=ts&"
import style0 from "./TagsComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports